module.exports = __webpack_public_path__ + "img/ext-02.1f2f071e.jpg";